import React from 'react';

const AdminPanel = () => (
  <div>
    <div>TODO</div>
    <div>1. Zakładka Ustawienia</div>
    <div>2. Zakładka Logowanie błędów</div>
  </div>
);

export default AdminPanel;
